import jwtDecode from 'jwt-decode';
import { PATH_AUTH } from '../routes/paths';
import axios from './axios';
import { storage, STORAGE_KEYS } from './storage';

const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }
  try {
    const decoded = jwtDecode<{ exp: number }>(accessToken);
    const currentTimeInDays = Date.now() / (1000 * 60 * 60 * 24); // convert ms to days
    const expInDays = decoded.exp / (60 * 60 * 24); // convert seconds to days
    return expInDays > currentTimeInDays;
  } catch (error) {
    return false;
  }
};

const handleTokenExpired = (exp: number) => {
  let expiredTimer;
  const currentTime = Date.now();
  const expTime = exp * 1000; // convert seconds to ms
  const timeLeft = expTime - currentTime;

  clearTimeout(expiredTimer);

  if (timeLeft > 0) {
    expiredTimer = setTimeout(async () => {
      alert('Token expired');

      await storage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);

      window.location.href = PATH_AUTH.login;
    }, timeLeft);
  }
};

const setSession = async (accessToken: string | null) => {
  if (accessToken) {
    await storage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode<{ exp: number }>(accessToken);
    handleTokenExpired(exp);
  } else {
    await storage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    delete axios.defaults.headers.common.Authorization;
  }
};

// Synchronous version for cases where async is not possible
const setSessionSync = (accessToken: string | null) => {
  if (accessToken) {
    storage.setItemSync(STORAGE_KEYS.ACCESS_TOKEN, accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    const { exp } = jwtDecode<{ exp: number }>(accessToken);
    handleTokenExpired(exp);
  } else {
    storage.setItemSync(STORAGE_KEYS.ACCESS_TOKEN, null);
    delete axios.defaults.headers.common.Authorization;
  }
};

export { isValidToken, setSession, setSessionSync };
